import React from 'react';
import { Zoom, Fade } from 'react-reveal/';
import renderHTML from 'react-render-html';
import { images } from '../../settings';

import './Hero.scss';
class Hero extends React.Component {
  constructor(props) {
    super(props)
    this.images = images
  }
 render() {
   this.bgHero = { backgroundImage: `url("${this.props.background}")`}
   return (
    <div className={`${this.props.classe} hero-top`}>
      {this.props.estilo == 'heroDefault' ? (
        <div className="hero" >
          <div className="container-titulo-hero">
            <img src={this.images.associados.icon_titulo} alt="icon titulo" />
            <h1
              className="hero__titulo"
              dangerouslySetInnerHTML={{ __html: this.props.titulo }}
            />
          </div>
          <div className="hero__content container">
              <div className="hero__texto-esquerda">
                
                {/* <h3
                  className="hero__subtitulo"
                  dangerouslySetInnerHTML={{ __html: this.props.subtitulo }}
                /> */}
                <h3 className="hero__subtitulo">
                  <span className="gri_text">
                    {renderHTML(this.props.subtitulo)}<br/>
                    {this.props.gri && <div className="gri_label gray gri_left">GRI <b>{this.props.gri}</b></div>}
                  </span>
                </h3>
              </div>
              <Fade bottom>
                <div className="hero__imagem-direita">
                  <img src={this.props.imagem} alt="Cidade Associados" />
                </div>
              </Fade>
          </div>
        </div>
        ) : (
          // <div className="container hero hero-associados--auto" style={this.bgHero}>
          //   <div className="hero__content container">
          //     <div className="hero__texto-esquerda hero__texto-esquerda--maior">
          //       <p className="hero__subtitulo">Além das tecnologias digitais, não dispensamos o bom e velho contato pessoal para ouvir o que os representantes das instituições têm a dizer: visitamos 58 associados neste ano. Também foram feitos três eventos de relacionamento: um happy hour em São Paulo, para celebrar conquistas, e dois almoços com gestoras no Rio de Janeiro.</p>
          //       <div className="container-visitas__anos">
          //         <span className="container-visitas__textos container-visitas__ano-2019">2019</span>
          //         <Zoom>
          //           <span className="container-visitas__textos container-visitas__texto-2019">58 visitas</span>
          //         </Zoom>
          //         <span className="container-visitas__textos container-visitas__ano-2018">2018</span>
          //         <Zoom>
          //           <span className="container-visitas__textos container-visitas__texto-2018">45 visitas</span>
          //         </Zoom>
          //         <span className="container-visitas__textos container-visitas__ano-2017">2017</span>
          //         <Zoom>
          //           <span className="container-visitas__textos container-visitas__texto-2017">40 visitas</span>
          //         </Zoom>
          //       </div>
          //     </div>
          //     <Fade right>
          //       <div className="hero__imagem-direita hero__imagem-direita--bottom">
          //         <img src={this.images.associados.casalMesa} alt="Casal Mesa" />
          //       </div>
          //     </Fade>
          //   </div>
          // </div>
          <div></div>
        )}
    </div>
   )
 }
}
export { Hero }